module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Pause-6b181bf0f40deef6c6d579a5561483e7.svg";